import { render } from "./EntityEditPage.vue?vue&type=template&id=1da83f32"
import script from "./EntityEditPage.vue?vue&type=script&lang=js"
export * from "./EntityEditPage.vue?vue&type=script&lang=js"
script.render = render

export default script